setTooltipNotranslate = ($el) ->
  tooltip = $(".js-tooltip .tooltip-inner-wrapper");
  return if !tooltip.length

  notranslate = $el.closest("[notranslate]").length  > 0
  if notranslate
    tooltip[0].setAttribute('notranslate', true)
  else
    tooltip[0].removeAttribute('notranslate')

notranslateTooltipHTML = ($el) ->
  notranslate = $el.closest("[notranslate]").length  > 0
  return ($("<var/>").text($el.text()))[0].outerHTML if notranslate

  preserveTags = ['var', 'time']
  page.get("HtmlUtils").textFromNodePreservingTags($el, preserveTags)

setTooltipContent = (value, isHtml=false) ->
  $tt = $(".js-tooltip .tooltip-inner-wrapper")
  if isHtml
    $tt.html value
  else
    $tt.text $.trim(value)

setTooltipPosition = (el) ->
  tooltip = $(".js-tooltip")
  tooltipInner = $(".tooltip-inner-wrapper", tooltip)

  tooltip.addClass("active")
  tooltipInnerWidth = tooltipInner.outerWidth()
  tooltipHeight = $(".tooltip", tooltip).height()

  pageBleed = 10

  elTop = el.offset().top - $(document).scrollTop()
  elLeft = el.offset().left
  elHeight = el.height()

  # switch if tooltip predicted to be off screen
  elPosition = el.data("tooltip-position")
  if elPosition is "left"
    if (elLeft - tooltipInnerWidth - 5) < pageBleed
      elPosition = "above"

  # position the tooltip
  switch elPosition
    when "left"
      # vertically align tooltip
      if elHeight > tooltipHeight
        elTop += Math.floor((elHeight - tooltipHeight) / 2)
      else
        elTop -= Math.floor((tooltipHeight - elHeight) / 2)

      tooltip.addClass("js-tooltip-left").css
        top: elTop
        left: elLeft - tooltipInnerWidth - 5
        width: tooltipInnerWidth
    else
      # default is above
      tooltip.css
        top: elTop
        width: el.outerWidth()

      # width must already be set in order to bleed screen
      if (elLeft + tooltipInnerWidth) > $(window).width()
        # check if bleeding off right side
        tooltip
          .addClass("js-tooltip-bleed-right")
          .css("right", pageBleed)
      else
        tooltip.css("left", elLeft)

        if tooltipInner.offset().left < pageBleed
          # check if bleeding off left side (after centering)
          tooltip
            .addClass("js-tooltip-bleed-left")
            .css("left", pageBleed)

$(document).on "mouseenter", "[data-behavior~=tooltip]", (e) ->
  el = $(e.currentTarget)
  unless el.hasClass("js-prevent-tooltip")
    tooltipText = el.data("tooltip-text")
    setTooltipNotranslate(el)
    setTooltipContent(tooltipText || el.attr("title"))
    setTooltipPosition(el)

$(document).on "mouseenter", ".ellipsis-text", (e) ->
  # this should be renamed to a behavior in the future
  el = $(e.currentTarget)
  if @offsetWidth < @scrollWidth
    setTooltipContent(notranslateTooltipHTML(el), true)
    setTooltipPosition(el)

    $(".js-tooltip").addClass("active-ellipsis")

contently.ui.closeTooltip = (e) ->
  unless $(e.relatedTarget).is(".js-tooltip.active, .js-tooltip.active *")
    $(".js-tooltip")
      .attr("class", "js-tooltip")
      .attr("style", "")

$(document).on "mouseleave", ".ellipsis-text, [data-behavior~=tooltip], .js-tooltip", contently.ui.closeTooltip



// WEBPACK FOOTER //
// ./app/javascript/lib/toolkit/behaviors/tooltips.js.coffee